const customerId = document.currentScript.getAttribute('customer-id') || "";
const productId = document.currentScript.getAttribute('product-id') || "";
const templateName = document.currentScript.getAttribute('template-name') || "";
const baseURL = 'https://phpstack-1046663-5815131.cloudwaysapps.com/api';

async function accessCustomerCollections() {
    try {
        var formData = new FormData();
        formData.append('shop', Shopify.shop);
        formData.append('customer_id', customerId);

        await fetch(`${baseURL}/access_customer_collections`, {
            method: 'POST',
            body: formData
        })
        .then((response) => response.json())
        .then((result) => {
            if (result?.success == 'true') {
                const collectionObj = result?.data;
                const handles = collectionObj.map(item => item.handle);
                if (handles.length > 1) {
                    fetch(`/?sections=custom-list-collections&handles=${handles.join(',')}`)
                    .then(res => res.json())
                    .then(html => document.getElementById("collections-container").innerHTML = html['custom-list-collections']);
                } else {
                    location.href = `/collections/${handles.join(',')}`;
                }
            }
        });
    } catch (error) {
        console.error(error.message);
    }
}

async function checkAssignedProductInCollection() {
    try {
        var formData = new FormData();
        formData.append('shop', Shopify.shop);
        formData.append('customer_id', customerId);
        formData.append('product_id', productId);

        await fetch(`${baseURL}/check_assigned_product_in_collection`, {
            method: 'POST',
            body: formData
        })
        .then((response) => response.json())
        .then((result) => {
            result?.success == 'false' && (location.href = '/pages/stores');
        });
    } catch (error) {
        console.error(error.message);
    }
}

document.addEventListener('DOMContentLoaded', async function() {
    console.log('Document is fully loaded and parsed!');

    // Your code to execute after the DOM is ready
    if (templateName == 'page.stores') {
        await accessCustomerCollections();   
    }

    if (templateName == 'product') {
        checkAssignedProductInCollection();
    }
});
